import './styles.less';
import { FC, useContext } from 'react';
import { AppContext } from '../../App';
import { ILSTypographyTitle } from '@components/general/typography';

export const ILSModuleTitle: FC = () => {
  const { title } = useContext(AppContext);
  return <ILSTypographyTitle className="ils-module-title">{title}</ILSTypographyTitle>;
};
